<app-parameter-card [title]="title">
  <div class="highlight" >{{selected}}</div>
  <div class="image-container" >
    <img *ngFor="let option of parameterData.options"
         [class.selected]="selected === option.value"
         class="round"
         [src]="option.image" [title]="option.name" (click)="handle(option.value)"/>
  </div>
</app-parameter-card>
